import { IData } from '../interface';

const loadExceptionReportJs = (data: IData) => {
    if (data.SYSTEM === '"CN"' || data.SYSTEM === 'CN') {
        return `<script src="https://statics-cdn-cn.umucdn.cn/common/reportException.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>`;
    }
    return '<script src="https://cdn.umustatic.com/common/reportException.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>';
};

const getLogUrl = (data: IData) => {
    const SYSTEM_LOG_URL_MAP = {
        '"CN"': 'https://log.umu.cn/hm.gif',
        'CN': 'https://log.umu.cn/hm.gif',
        '"TW"': 'https://log.umu.tw/hm.gif',
        'TW': 'https://log.umu.tw/hm.gif',
        '"JP"': 'https://log.umu.co/hm.gif',
        'JP': 'https://log.umu.co/hm.gif',
        '"EN"': 'https://log.umu.com/hm.gif',
        'EN': 'https://log.umu.com/hm.gif',
        '"EM"': 'https://log.umu.io/hm.gif',
        'EM': 'https://log.umu.io/hm.gif',
    };

    return SYSTEM_LOG_URL_MAP[data.SYSTEM] || '';
};

const enableDevLogInfoIfNeeded = (data: IData): string | void => {
    if (!data.IS_PRODUCTION) {
        return `
            if (window.location.href.indexOf('debug_exception=1') == -1) {
                options.submit = function (url) {
                    console.log(url);
                }
            }
        `;
    }
};

const render = (data: IData) => {
    return `
        ${loadExceptionReportJs(data)}
        <script>
            (function () {
                var options = {
                    id: 1,
                    url: '${getLogUrl(data)}',
                    level: 4,
                    random: 1,
                    ext: {
                        log_biz_tag_type: window.log_biz_tag_type || 'umu-mobile'
                    }
                };
                ${enableDevLogInfoIfNeeded(data)}
                BJ_REPORT.init(options);
            })();
        </script>
    `;
};

export default render;
